import {TextFieldModule} from '@angular/cdk/text-field';
import {APP_INITIALIZER, NgModule, Provider} from '@angular/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MAT_SNACK_BAR_DEFAULT_OPTIONS} from '@angular/material/snack-bar';
import {MAT_TOOLTIP_DEFAULT_OPTIONS} from '@angular/material/tooltip';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouteReuseStrategy} from '@angular/router';
import {
  AccessibilityManagerModule,
  ConfigurationService,
  DocumentRootService,
  DocumentService,
  FragmentIndexingService,
  FragmentService,
  SectionService,
  TSESAuthenticationModule,
  TSESFragmentModule,
  TSESLoggingModule,
} from '@nh/angular-tses';
import {VERSION} from 'environments/version';
import {environment} from '../environments/environment';
import {DASCoreModule} from './core/das-core.module';
import {EnvironmentVariableService} from './core/services/environment-variable.service';
import {CustomRouteReuseStrategy} from './custom-route-strategy';
import {DasRoutingModule} from './das-routing.module';
import {DasComponent} from './das.component';
import {DasFragmentModule} from './fragment/das-fragment.module';
import {DasFragmentIndexService} from './fragment/indexing/das-fragment-index.service';
import {DAS_CUSTOM_CLAUSE_TYPES} from './fragment/types/das-clause-type-registrations';
import {DAS_CUSTOM_REGISTRATIONS} from './fragment/types/das-fragment-registrations';
import {ModalsModule} from './transition/modals/modals.module';
import {DasVersionCheckerService} from './version/das-version-checker.service';

const DECLARATIONS = [DasComponent];

const IMPORTS = [
  MatProgressSpinnerModule,
  BrowserModule,
  BrowserAnimationsModule,
  DasRoutingModule,
  TSESFragmentModule,
  TSESAuthenticationModule,
  DasFragmentModule,
  DASCoreModule,
  ModalsModule,
  TSESLoggingModule.forRoot(),
  AccessibilityManagerModule,
  TextFieldModule,
];

const BOOTSTRAP = [DasComponent];

const PROVIDERS: Provider[] = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    deps: [
      ConfigurationService,
      DocumentRootService,
      SectionService,
      FragmentIndexingService,
      FragmentService,
      DocumentService,
      EnvironmentVariableService,
    ],
    useFactory: initializerFactory,
  },
  {
    provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
    useValue: {showDelay: environment.tooltipDelay},
  },
  {
    provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
    useValue: {duration: environment.snackbarDuration},
  },
  {provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy},
  DasVersionCheckerService,
];

export function initializerFactory(
  configurationService: ConfigurationService,
  documentRootService: DocumentRootService,
  sectionService: SectionService,
  fragmentIndexingService: FragmentIndexingService,
  fragmentService: FragmentService,
  documentService: DocumentService,
  environmentVariableService: EnvironmentVariableService
) {
  function configure() {
    configurationService.configure(environment.tsesConfig);
    configurationService.version = VERSION;
    fragmentIndexingService.setIndexer(new DasFragmentIndexService(fragmentService, documentService));
    documentRootService.registerCustomTypes(DAS_CUSTOM_REGISTRATIONS);
    sectionService.registerClauseTypes(...DAS_CUSTOM_CLAUSE_TYPES);
    environmentVariableService.loadConfig();
  }

  return configure;
}

@NgModule({
  declarations: DECLARATIONS,
  imports: IMPORTS,
  bootstrap: BOOTSTRAP,
  providers: PROVIDERS,
})
export class DasModule {}
